<template>
    <ies-form-field :field="field">
        <div class="d-flex flex-column">
            <input type="hidden" :name="field.fieldName" :value="field.value">

            <v-radio-group
                v-model="billing"
                row
                autocomplete>
                <v-radio label="Upfront Deposit"	:value="1"></v-radio>
                <v-radio label="In Arrears"			:value="0"></v-radio>
            </v-radio-group>
        </div>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-input-billing-type',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
			billing: parseInt(this.field.value),
        }
    },

	watch: {
		billing: function (newValue) {
			this.field.value = newValue;
		}
	}	
}
</script>
